export const HOME_TITLE = [
  "Chơi ngay nhận lộc mùa Hè",
  "Thưởng Nạp cực cao lên đến"
];

export const CONTRACTS = {
  facebook: "https://www.facebook.com/nhacai8day",
  telegram: "https://t.me/cskh8day"
};

export const FORM_VALID_MESSAGE = {
  loginFailTitle: "ĐĂNG NHẬP THẤT BẠI",
  registerFailTitle: "ĐĂNG KÝ THẤT BẠI",
  emptyMsg: "* Vui lòng điền đầy đủ thông tin.",
  usernameFormatErr: "* Tên đăng nhập phải từ 4 đến 20 kí tự.",
  passwordMsg: "Mật khẩu phải từ 6 đến 15 kí tự.",
  emailInvalid: "Định dạng email chưa chính xác.",
  phoneInvalid: "Định dạng phone chưa chính xác",
  emailFormatErr: "* Chỉ chấp nhận email @gmail.com ,@yahoo.com .",
  loggedTitle: "ĐĂNG NHẬP THÀNH CÔNG",
  loggedMsg: "* Bạn đang được chuyển về trang chủ 8day Vui lòng chờ trong 5s.",
  registerTitle: "ĐĂNG KÝ THÀNH CÔNG",
  registerMsg: "* Chúc mừng bạn đã đăng ký thành công! Tự động đăng nhập trong 5s."
};

export const DOMAIN_AGENT_CODE = {
  "ls1v.xkiosx.xyz": "ls1v",
  "aupk.xkiosx.xyz": "aupk",
  "nohu.8day888.info": "l6a1",
  "banca.8day888.info": "l6a1",
  "loc.8day888.info": "l6a1",
  "vaobo.8day888.info": "l6a1",
  "n0t0.8day888.info": "l6a1",
  "n0hu.8day888.info": "l6a1",
  "l0cla.8day888.info": "l6a1",
  "vui.8day888.info": "l6a1",
  "8day888.info": "l6a1",
  "locla.8day88.com": "3jvq",
  "nhanloc.8day88.com": "3jvq",
  "vaobo.8day88.com": "3jvq",
  "noto.8day88.com": "3jvq",
  "banca.8day888.vip": "fl7j",
  "nhanloc.8day888.vip": "fl7j",
  "nohu.8day888.vip": "fl7j",
  "vuichoi.8day.cc": "gj9a",
  "giaitri.8day.cc": "gj9a",
  "nhanloc.8day.cc": "gj9a",
  "khuyenmai.8day.cc": "gj9a",
  "banca.xkiosx.xyz": "aupk",
  "bongda.xkiosx.xyz": "aupk",
  "loc.xkiosx.xyz": "aupk",
  "nohu.8day.world": "lyoz",
  "locla.8day.world": "4zdk",
  "voucher.8day.world": "d3m4",
  "l0cla.8dayvn666.com": "3jvq",
  "vaobao.8dayvn666.com": "3jvq",
  "n0hu.8dayvn666.com": "3jvq",
  "l0de.8dayvn666.com": "3jvq",
  "8day888.com": "amm2",
  "tanthu.8day888.com": "amm2",
  "vebo.8day888.com": "amm2",
  "khuyenmai.8day888.com": "amm2",
  "nhanloc.8day888.com": "amm2",
  "8dayvn.work": "amm2",
  "tanthu.8dayvn.work": "amm2",
  "locla.8dayvn.work": "amm2",
  "nhanloc.8dayvn.work": "amm2",
  "8dayvn.win": "3khj",
  "giaitri8day.com": "xq5j",
  "tanthu.8dayvn.win": "3khj",
  "nhanloc.8dayvn.win": "3khj",
  "khuyenmai.8dayvn.win": "3khj",
  "tanthu.8day.website": "5li5",
  "nhanloc.8day.website": "5li5",
  "khuyenmai.8day.website": "5li5",
  "tanthu.8day.tech": "6q9c",
  "vaob0.8day.tech": "6q9c",
  "nhanl0c.8day.tech": "6q9c",
    "giftc0de.8day.world":"n06g",
    "c0de.8day.world":"3ylk",
    "nhanqua.8day.world":"mcqi",

    "va0bo.8day66.com":"asto",
    "xs.8day66.com": "5el2",
    "banca.8day66.com":	"7oe1",
    "n0hu.8day66.com": "jdwq",
    "loto.8day66.com":	"560c",
    "s0de.8day66.com":	"c8hi",
    "loc.8day66.com":	"1e74",
    "mienphi.8day66.com": "y7sg",
    "52la.8day66.com":	"ooks",
    "tienlen.8day66.com": "qkw8",
    "xidach.8day66.com": "7mvk",
    "bong.8day66.com":	"oove",
    "lixi.8day66.com":	"g3yj",
    "cuong.8day.email":	"e1v9",
    "C0de.8day66.com":	"pnh6b",
    "daga.8day66.com":	"qoa86",
    "phut89.8day66.com":	"17w43",
    "vietlott.8day66.com":	"pjl86",
    "daily.8day66.com":	"8kexq",
    "ketqua.8day66.com":	"60fmf",
    "banhmi.8day66.com":	"a0xh8",
    "xoilac.8day66.com":	"zc1dz",
    "banca.8day41.com":	"25qhz",
    "hotbac.8day42.com":	"la06i",
    "v0ngquay.8day43.com":	"u4krd",
    "santien.8day44.com":	"p72vs",
    "uytin.8day45.com":	"ll3c2",
    "ke0hay.8day46.com":	"gp9lt",
    "huto.8day47.com":	"523n4",
    "phatl0c.8day48.com":	"4vods",
    "soco.8day49.com":	"8m8lb",
    "top1.8day.coffee":	"so22q",
    "8day.camp":"79vnk",
    "doithuong.8day66.com":"iby5r",
    "vui.8day66.com": "6xzhu",
    "sanhu.8day66.com": "sumdy",
    'tanthu.8dayvn.com':'lo19',
    'mayman.8dayvn.com':'lo19',
    'banca.8dayvn.com':'lo19',
    'n0hu.8dayvn.com':'lo19'


    // "loc.8day888.info":	"vnmkt03",
    // "banca.8day888.vip": "vnmkt05",
    // "vuichoi.8day.cc": "vnmkt06",
    // "tanthu.8day.website": "vnmkt07",
    // "tanthu.8dayvn.work": "vnmkt08",
    // "khuyenmai.8dayvn.win":"vnmkt09",
    // nhanl0c.8day.tech	vnmkt10

};

export const DOMAIN_AGENT_CODE_MAP = new Map([
  ["nhanloc.8day66.com", "7nya"],
  ["khuyenmai.8day66.com", "7nya"],
  ["nhanl0c.8day66.com", "7nya"],
  ["uudai.8day66.com", "7nya"],
  ["km.8day66.com", "7nya"],
  ["phatloc.8day66.com", "7nya"],
  ["phatl0c.8day66.com", "7nya"],

  ["banca.8day.net", "9dxe"],
  ["bong.8day.net", "9dxe"],
  ["nohu.8day.net", "9dxe"],
  ["xs.8day.net", "9dxe"],
  ["uytin.8day.net", "9dxe"],
  ["hot.8day.net", "9dxe"],
  ["vip.8day.net", "9dxe"],
  ["loc.8day.net", "9dxe"],
  ["km.8day.net", "9dxe"],
  ["uudai.8day.net", "9dxe"],

  ["tanthu.8day66.com", "uu9e3"],
  ["mphi.8day66.com", "uu9e3"],
  ["vebo.8day66.com", "uu9e3"],
  ["l0de.8day66.com", "uu9e3"],
  ["huto.8day66.com", "uu9e3"],
  ["bommau.8day66.com", "uu9e3"],
  ["hoanthua.8day66.com", "uu9e3"],

  ["mayman.8day66.com", "308ht"],
  ["antoan.8day66.com", "308ht"],
  ["sanchoi.8day66.com", "308ht"],
  ["chicai.8day66.com", "308ht"],
  ["uytin.8day66.com", "308ht"],
  ["nap.8day66.com", "308ht"],
  ["hoantra.8day66.com", "308ht"],

  ["hot.8day66.com", "y7jxr"],
  ["free.8day66.com", "y7jxr"],
  ["voucher.8day66.com", "y7jxr"],
  ["tangl0c.8day66.com", "y7jxr"],
  ["baicao.8day66.com", "y7jxr"],
  ["no1.8day66.com", "y7jxr"],
  ["thangto.8day66.com", "y7jxr"],

  ["tangthuong.8day66.com", "iby5r"],
  ["play.8day66.com", "iby5r"],
  ["doithuong.8day66.com", "iby5r"],
  ["choivui.8day66.com", "iby5r"],
  ["quayhu.8day66.com", "iby5r"],
  ["winner.8day66.com", "iby5r"],
  ["dangky.8day66.com", "iby5r"],

  ["best.8day66.com", "6xzhu"],
  ["l0c.8day66.com", "6xzhu"],
  ["vui.8day66.com", "6xzhu"],
  ["l0cla.8day66.com", "6xzhu"],
  ["phattai.8day66.com", "6xzhu"],
  ["vuichoi.8day66.com", "6xzhu"],
  ["phatthuong.8day66.com", "6xzhu"],

  ["giaitri.8day66.com", "sumdy"],
  ["santhuong.8day66.com", "sumdy"],
  ["win.8day66.com", "sumdy"],
  ["nhanthuong.8day66.com", "sumdy"],
  ["sanhu.8day66.com", "sumdy"],
  ["quayxeng.8day66.com", "sumdy"],
  ["batca.8day66.com", "sumdy"],

  ["giftc0de.8day.world", "n06g"],
  ["c0de.8day.world", "3ylk"],
  ["nhanqua.8day.world", "mcqi"],
    ["8day.camp", "79vnk",]
]);

export const GOOGLE_TAG_MANAGERS = {
  "nohu.8day.world": "GTM-WR9VJ5J"
};

export const DOMAIN_GOOGLE_GTAG = {
  "ls1v.xkiosx.xyz": "G-8QZH5YDEJX",
  "aupk.xkiosx.xyz": "G-M53P3QFRM1",
  "8day.cc": "G-C0LB00T292",
  "nohu.8day888.info": "G-DVT6DBKNXG",
  "banca.8day888.info": "G-4HZSJFHEGB",
  "loc.8day888.info": "G-E4X0D19CWY",
  "8day888.info": "G-43N1G1SG02",
  "8day88.com": "G-Y5PFQV2YPX",
  "8day888.vip": "G-TWF6M8SZ4V",
  "locla.8day88.com": "G-QBLHNKJR72",
  "nhanloc.8day88.com": "G-XSK8J84WMW",
  "vaobo.8day88.com": "G-EFQGW9JT3V",
  "noto.8day88.com": "G-SKGD6XN5TH",
  "mini.8day888.xyz": "G-88ZV7RMBEP",
  "nohu.8day.world": "G-VCK2XVJVZ9",
  "locla.8day.world": "G-DNMFMBHYQS",
  "8day.best": "G-3ZTGXDMBPV",
  "8day.website": "G-58ED6BE75R",
  "l0cla.8dayvn666.com": "G-FER043EDGS",
  "vaobao.8dayvn666.com": "G-9BRSN3388M",
  "n0hu.8dayvn666.com": "G-3N25C7YP3P",
  "l0de.8dayvn666.com": "G-VYC90SBJRZ",
  "tanthu.8day888.com": "G-NTECJ248GP",
  "khuyenmai.8day888.com": "G-2BTVTF1GN7",
  "8day.work": "G-JFS0LFF16H",
  "giaitri8day.com": "G-58PB0XEZS5",
  "8dayvn8.com": "G-GJR12269VW",
  "vuichoi.8day.cc": "G-QHR9KPRQLQ",
    "giftc0de.8day.world":"G-ZC2CYKMPK1",
    "c0de.8day.world":"G-NJ2E4SZCTQ",
    "nhanqua.8day.world":"G-4VHL9DJ9XH"
};

export const PHONES_PREFIX_REPLACE = {
  "0162": "032",
  "0163": "033",
  "0164": "034",
  "0165": "035",
  "0166": "036",
  "0167": "037",
  "0168": "038",
  "0169": "039",
  "0120": "070",
  "0121": "079",
  "0122": "072",
  "0126": "076",
  "0128": "078",
  "0123": "083",
  "0124": "084",
  "0125": "085",
  "0127": "081",
  "0129": "082",
  "0182": "052",
  "0186": "056",
  "0188": "058",
  "0199": "059"
};

export const PHONES_PREFIX_FORE = [
  "0162",
  "0163",
  "0164",
  "0165",
  "0166",
  "0167",
  "0168",
  "0169",
  "0120",
  "0121",
  "0122",
  "0126",
  "0128",
  "0123",
  "0124",
  "0125",
  "0127",
  "0129",
  "0182",
  "0186",
  "0188",
  "0199"
];

export const PHONES_PREFIX_THREE = [
  "086",
  "096",
  "097",
  "098",
  "032",
  "033",
  "034",
  "035",
  "036",
  "037",
  "038",
  "039",
  "070",
  "079",
  "072",
  "076",
  "078",
  "089",
  "090",
  "093",
  "077",
  "088",
  "091",
  "094",
  "083",
  "084",
  "085",
  "081",
  "082",
  "092",
  "052",
  "056",
  "058",
  "019",
  "059",
  "099",
  "095",
  "043",
  "087"
];

export const THREE_REG = /^0(86|96|97|98|32|33|34|35|36|37|38|39|70|79|72|76|78|89|90|93|77|88|91|94|83|84|85|81|82|92|52|56|58|19|59|99|95|43|87)([0-9]{7})/g;


export const DOMAIN_INVITE_CODE = {
  "ads23.win888b.com": "1rsn",
  "tien8666.vip": "30ca",
  "nohuto888.vip": "30ca",
  "vuixoso.com": "e721",
  "fb888b.com": "72e5",
  "dap-hu.online": "677b",
  "vip.noto888.vip": "ecf1",
  "hot.noto888.vip": "ecf1",
  "km.noto888.vip": "ecf1",
  "qc.noto888.vip": "ecf1",
  "vip.ta888b.com": "c9f9",
  "hot.ta888b.com": "c9f9",
  "km.ta888b.com": "c9f9",
  "hot.sl888b.com": "677b",
  "km.sl888b.com": "677b",
  "qc.sl888b.com": "677b",
  "vip.sl888b.com": "677b",
  "site.sl888b.com": "677b",
  "ld888b.com": "f9b9",
  "probet68.com": "677b",
  "sl888b.com": "677b",
  "banca888b.com": "2737",
  "ta888b.com": "c9f9",
  "qc.km8888b.com": "be9f",
  "km2888b.com": "uv8c",
  "km3888b.com": "3qxy",
  "noto888.vip": "ecf1",
  "38b8876.vip": "41ca",
  "loc.win888bwiner.top": "c875",
  "free.win888bwiner.top": "28a8",
  "mayman888.vip": "72e5",
  "thang888.vip": "e67e",
  "888b.life": "72E5",
  "quayrulet.com": "30ca",
  "cannhantai247.com": "be9f",
  "888bminigame.com": "7821",
  "quay-rulet.info": "62ef",
  "km0888b.com": "e67e",
  "bancavip888b.com": "30ca",
  "miencuclac.xyz": "72e5",
  "hot.vi888b.com": "1c98",
  "ads01.win888b.com": "2737",

  "ads02.win888b.com": "0383",
  "ads03.win888b.com": "0160",

  "ads04.win888b.com": "63ca",
  "ads05.win888b.com": "328b",
  "ads06.win888b.com": "e7b5",
  "ads07.win888b.com": "c75a",
  "ads08.win888b.com": "4bff",
  "ads09.win888b.com": "a9b6",
  "ads10.win888b.com": "6d9d",
  "ads11.win888b.com": "3951",
  "ads12.win888b.com": "2c2f",
  "ads13.win888b.com": "7124",
  "ads14.win888b.com": "9b7e",
  "ads15.win888b.com": "b251",
  "ads16.win888b.com": "658e",
  "ads17.win888b.com": "64zi",

  "ads21.win888b.com": "ahrz",
  "ads22.win888b.com": "6iom",

  "ads25.win888b.com": "cw4b",

  "ads26.win888b.com": "83ur",

  "ads27.win888b.com": "lgb0",
  "ads28.win888b.com": "jynx",

  "bancamap888.vip": "0923",
  "km.bancamap888.vip": "0923",
  "cm.bancamap888.vip": "0923",
  "hot.bancamap888.vip": "0923",
  "8886688.vip": "a18a",
  "anto8866.vip": "e721",
  "km7888b.com": "e543",
  "si888b.com": "9a94",
  "vi888b.com": "0923",
  "banca888b.club": "72e5",
  "nohu888b.club": "72e5",
  "bong888b.club": "72e5",
  "thethao888b.club": "72e5",
  "gamebai888b.club": "72e5",
  "888b.world": "7821",
  "loc.km8888b.com": "be9f",
  "win888bwiner.top": "mnj9",
  "xs.888b.world": "7821",
  "l0t0.888b.world": "7821",
  "sanca.888b.world": "7821",
  "l0de.888b.world": "7821",
  "locla.888b.world": "7821",
  "go888b.com": "e67e",
  "mienphi.win888bwiner.top": "mnj9",
  "km.win888bwiner.top": "mnj9",
  "hot.si888b.com": "9a94",
  "site.si888b.com": "9a94",
  "km.si888b.com": "9a94",
  "site.go888b.com": "e67e",
  "vip.go888b.com": "e67e",
  "hot.go888b.com": "e67e",
  "hot.mayman888.vip": "72e5",
  "vip.mayman888.vip": "72e5",
  "km.mayman888.vip": "72e5",
  "vebo.888bvn.vip": "30ca",
  "vip.8886688.vip": "a18a",
  "km.8886688.vip": "a18a",
  "qc.8886688.vip": "a18a",
  "hot.8886688.vip": "a18a",
  "cm.8886688.vip": "a18a",
  "xs.888bvn.vip": "30ca",
  "tanthu.888bvn.vip": "30ca",
  "khuyenmai.888bvn.vip": "30ca",
  "nhanloc.888bvn.vip": "30ca",
  "hot.888bvn.vip": "30ca",
  "km.888bvn.vip": "30ca",
  "phatloc.888bvn.vip": "30ca",
  "tangloc.888bvn.vip": "30ca",
  "thuongloc.888bvn.vip": "30ca",
  "ns888b.com": "30ca",
  "mphi.888bvn.vip": "30ca",
  "km.anto8866.vip": "e721",
  "hot.anto8866.vip": "e721",
  "vip.anto8866.vip": "e721",
  "qc.anto8866.vip": "e721",
  "bongda888b.com": "jynx",
  "c0de.buotnao.xyz": "0d1a",
  "xaloc.buotnao.xyz": "0d1a",
  "choi.buotnao.xyz": "0d1a",
  "loc.soi-kau.live": "0d1a",
  "vui.soi-kau.live": "0d1a",
  "test.soi-kau.live": "0d1a",
  "tanthu.dl38b17.club": "c9f9",
  "km.dl38b17.club": "c9f9",
  "banca.dl38b17.club": "c9f9",
  "dl38b17.club": "c9f9",
  "888b88.net": "2yrwe",
  "vn888b.com": "jeybp",
  "888b.earth": "7yyg3",

  "vuimung.888b.world": "7821",
  "cm.888b.world": "7821",
  "tanthu.8bgame.club": "9a94",
  "km.vip8b.today": "bf50",
  "tanthu.vip8b.today": "bf50",
  "locla.vip8b.today": "bf50",
  "tangqua.tanthu.xyz": "c91d",
  "locla.tanthu.xyz": "c91d",
  "km.tanthu.xyz": "c91d",
  "tanthu.888b.bid": "c7lyi",
  "mayman.888b.bid": "c7lyi",
};


// WEBPACK FOOTER //
// ./src/utils/constant.js